import React, { useMemo } from 'react'
import { useResultsState } from 'src/context/results'
import { NoResultsBold as SearchResultsBold } from 'src/views/directory/styled/NoResultsFound.styled'
import { CounterContainer, SrcNormalText } from './SearchResultsCounter.styled'

enum CounterShowDetails {
  NO,
  NO_RESULTS,
  YES,
}

export const SearchResultsCounter: React.FC<{
  showDetails?: CounterShowDetails
}> = ({ showDetails = CounterShowDetails.NO_RESULTS }) => {
  const [state] = useResultsState()

  const searchParametersText: string = [
    state.search?.serviceLines,
    state.search?.name,
  ]
    .filter(Boolean)
    .join(', ')

  const searchType = state.itemType
  const distance = state.filter?.distance || '20'
  const totalResults = state.totalCount

  let distanceToShowInMessage = distance

  if (state.isRequestCanceled) {
    distanceToShowInMessage = state.previousDistance
  }

  const countIdentification = useMemo(() => {
    if (
      showDetails === CounterShowDetails.NO ||
      (showDetails === CounterShowDetails.NO_RESULTS && totalResults !== 0)
    ) {
      if (searchType === 'facility') {
        return state.totalCount === 1 ? 'Facility' : 'Facilities'
      }
      return totalResults === 1 ? 'in-network result' : 'in-network results'
    }

    return searchParametersText
      ? `in-network results "${searchParametersText}"`
      : 'network providers'
  }, [state.totalCount, searchParametersText, searchType, showDetails])

  return (
    <CounterContainer>
      <SrcNormalText>
        <SearchResultsBold>
          <u>
            {totalResults} {countIdentification}
          </u>
        </SearchResultsBold>{' '}
        found within {distanceToShowInMessage} miles
      </SrcNormalText>
    </CounterContainer>
  )
}
